import type { PathArray } from "common/utils/formStructure";
import { Text } from "../../../../../../../Inputs/react-hook-form";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../../form/form";

type PlaceholderTextInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function PlaceholderTextInput({
  fieldPath,
  isReadOnly,
}: PlaceholderTextInputProps) {
  const { register } = useBuilderFormContext();
  const placeholderPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "placeholder",
  );

  return (
    <Text
      label="Placeholder text"
      disabled={isReadOnly}
      {...register(placeholderPropertyFormPath)}
    />
  );
}
